import React from 'react';
import Header from './header';
import Footer from './footer';
import WidgetContact from '../Widgets/widget-contact';

export default function Layout({ children }) {
    return (
        <div className="flex flex-col bg-backgroundColor min-h-screen">
            <Header />
            <main className="flex-1">{children}</main>
            <WidgetContact />
            <Footer />
        </div>
    );
};
